<template>
  <div v-if="showPrompt || showInstallClarify">
    <div
      v-if="showPrompt"
      class="a2hs-container"
    >
      <div class="a2hs-container__inner">
        <img
          alt="App Icon"
          class="a2hs-icon mb-3"
          src="/icons/icon-192.png"
        >
        <div class="a2hs-text-title">
          Install Satoshi Eye as an app?
        </div>
        <div class="a2hs-text__main-info mb-4">
          You’ll be able to use Satoshi Eye like a regular mobile app, without opening your browser.
        </div>

        <button
          class="gl-button gl-button--dark gl-form__button gl-button--padder gl-form__button-full mb-3"
          @click="installHandler"
        >
          Install
        </button>
        <button
          class="gl-button gl-form__button gl-button--padder gl-form__button-got-it gl-form__button-full"
          @click="cancelAction"
        >
          Cancel
        </button>
      </div>
    </div>
    <div
      v-if="showInstallClarify"
      class="a2hs-container"
    >
      <div class="a2hs-container__inner">
        <div class="a2hs-container__inner--install-support-block"/>
        <div class="a2hs-text-title">
          You can always install Satoshi Eye as an app!
        </div>
        <div class="a2hs-text__main-info mb-4">
          Just tap the install icon in the top menu.
        </div>
        <button
          class="gl-button gl-button--dark gl-form__button gl-button--padder gl-form__button-full mb-3"
          @click="showInstallClarify = false"
        >
          Got it
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Utils
import { checkIfIos, installPWA, shouldSkipPWAInstallCheck } from "@/utils/pwa-support";
// Vuex
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      isIos: false,
      showPrompt: false,
      deferredPrompt: null,
      showInstallClarify: false,
    }
  },
  mounted() {
    if (this.shouldSkipPWAInstallCheck()) return

    if (this.checkIfIos()) {
      setTimeout(() => {
        if (!sessionStorage.getItem('a2hs-dismissed')) {
          this.showPrompt = true
        }
      }, 3000)
    } else {
      window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
  },
  methods: {
    ...mapMutations({
      SET_IS_PROMPT_OPEN: 'sidebar/SET_IS_PROMPT_OPEN',
    }),
    checkIfIos,
    shouldSkipPWAInstallCheck,
    handleBeforeInstallPrompt(e) {
      e.preventDefault()
      this.deferredPrompt = e

      setTimeout(() => {
        if (!sessionStorage.getItem('a2hs-dismissed')) {
          this.showPrompt = true
        }
      }, 3000)
    },
    installHandler() {
      this.showPrompt = false
      this.showInstallClarify = false

      if (this.checkIfIos()) {
        this.SET_IS_PROMPT_OPEN(true)
      } else {
        this.SET_IS_PROMPT_OPEN(false)
        this.handlePwaInstall()
      }
    },
    async handlePwaInstall() {
      await installPWA({
        deferredPrompt: this.deferredPrompt,
        onCleanup: () => {
          this.cleanup()
        }
      })
    },
    cleanup() {
      this.showPrompt = false
      sessionStorage.setItem('a2hs-dismissed', 'true')
      this.deferredPrompt = null
    },
    cancelAction() {
      this.showInstallClarify = true
      this.showPrompt = false
      sessionStorage.setItem('a2hs-dismissed', 'true')
      this.deferredPrompt = null
    }
  }
}
</script>

<style scoped>
.a2hs-container {
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--Background-tint);
  //color: var(--white);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  z-index: 9999;
  width: 100%;
  height: 100%;
  font-family: 'Exo 2', sans-serif;
  gap: 12px;
  animation: slideUp 0.8s ease-out;
  //backdrop-filter: blur(5px);
}

.a2hs-container__inner {
  background-color: var(--white);
  border-radius: 24px;
  padding: 24px;
  width: 100%;
}

@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.a2hs-container img {
  display: flex;
  width: 56px;
  height: 56px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  background: var(--Basic-A-900, #FFF);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
}

.a2hs-container__inner--install-support-block {
  background: url('~@/assets/svg/background/pwa/install-support-bg.svg') no-repeat;
  height: 64px;
  margin-bottom: 16px;
}

.a2hs-text-title {
  color: var(--Basic-900, #091540);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Line-Height-3XL, 28px);
  font-size: 20px;
  margin-bottom: 8px;
}

.a2hs-text__main-info {
  color: var(--Basic-800, rgba(9, 21, 64, 0.68));
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.5px;
}

.a2hs-button {
  background: #007aff;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.a2hs-button:hover {
  background: #005bb5;
}

.a2hs-close {
  background: transparent;
  border: none;
  color: var(--white);
  font-size: 20px;
  margin-left: 12px;
  cursor: pointer;
  line-height: 1;
}

.a2hs-button {
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  margin-left: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
  background: var(--reflex-bluet);
}

.a2hs-button:hover {
  background: #415a77;
}


@media (max-width: 480px) {
  .a2hs-container {
    align-items: center;
    justify-content: space-between;
  }

  .a2hs-button {
    width: auto;
    flex: 1 1 auto;
  }
}
</style>
